import SocialPostsHomePage from "../components/SocialPostsHomePage.vue";

export default {
  children: [
    {
      path: "",
      name: "social-posts-home",
      component: SocialPostsHomePage,
      meta: { countViews: true },
    },
  ],
};
